var exports = {
  "kL": "xfb577c5e--762b14--container",
  "iE": "xfb577c5e--762b14--wrapper",
  "DD": "xfb577c5e--762b14--title",
};

module.exports = exports;
